import { Switch } from '@headlessui/react';
import { TrashIcon } from '@heroicons/react/24/outline';
import moment from 'moment';

export default function KinesisEventManagementCreateTableRow({
    newKinesisEventIndex,
    newKinesisEvent,
    eventTypeOptions,
    eventTerrainOptions,
    eventDistanceOptions,
    onNewEventDataEdit
}) {

    const HandleNewEventDataEdit = (propertyName, value = '') => {
        onNewEventDataEdit(newKinesisEventIndex, propertyName, value)
    }

    return (
        <div className='grid grid-cols-13 divide-x divide-gray-400'>

            {/* Event Priority */}
            <div className='col-span-1'>
                <div className='h-full flex items-center gap-x-1 bg-orange-100'>
                    <div>
                        <div className='ml-2 w-6 h-6 border border-gray-400 bg-white rounded-full flex items-center justify-center text-xs'>
                            {newKinesisEvent.eventType === 'a-race' ? 'A' : ''}
                            {newKinesisEvent.eventType === 'b-race' ? 'B' : ''}
                            {newKinesisEvent.eventType === 'c-race' ? 'C' : ''}
                        </div>
                    </div>

                    <select
                        className='w-full py-2 focus:outline-none border-r-[8px] cursor-pointer border-orange-100 bg-orange-100'
                        value={newKinesisEvent.eventType}
                        onChange={(e) => HandleNewEventDataEdit('eventType', e.target.value)}
                    >
                        {eventTypeOptions.map(option => (
                            <option key={option} value={option}>
                                {option.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Event Name */}
            <div className='col-span-2'>
                <input
                    type="text"
                    className='h-full w-full p-2 placeholder:text-gray-400 focus:outline-none bg-orange-100'
                    placeholder='Enter event name here'
                    value={newKinesisEvent.name}
                    onChange={(e) => HandleNewEventDataEdit('name', e.target.value)}
                />
            </div>

            {/* Event Terrain */}
            <div className='col-span-1'>
                <select
                    className='h-full w-full pl-2 py-2 focus:outline-none border-r-[8px] cursor-pointer border-orange-100 bg-orange-100'
                    value={newKinesisEvent.eventTerrain}
                    onChange={(e) => HandleNewEventDataEdit('eventTerrain', e.target.value)}
                >
                    {eventTerrainOptions.map(option => (
                        <option key={option.key} value={option.key}>
                            {option.title}
                        </option>
                    ))}
                </select>
            </div>

            {/* Custom Event Terrain */}
            <div className='col-span-1'>
                {newKinesisEvent.eventTerrain === 'other' && (
                    <input
                        type="text"
                        className='h-full w-full p-2 placeholder:text-gray-400 focus:outline-none bg-orange-100'
                        placeholder='Enter text'
                        value={newKinesisEvent.eventTerrainTextInput}
                        onChange={(e) => HandleNewEventDataEdit('eventTerrainTextInput', e.target.value)}
                    />
                )}

                {newKinesisEvent.eventTerrain !== 'other' && (
                    <div className="h-full px-2 py-2 bg-orange-100 text-gray-500 cursor-not-allowed">
                        N/A
                    </div>  
                )}
            </div>

            {/* Event Distance */}
            <div className='col-span-1'>
                <select
                    className='h-full w-full pl-2 py-2 focus:outline-none border-r-[8px] cursor-pointer border-orange-100 bg-orange-100'
                    value={newKinesisEvent.eventDistance}
                    onChange={(e) => HandleNewEventDataEdit('eventDistance', e.target.value)}
                >
                    {eventDistanceOptions.map(option => (
                        <option key={option.key} value={option.key}>
                            {option.title}
                        </option>
                    ))}
                </select>
            </div>

            {/* Custom Event Distance */}
            <div className='col-span-1'>
                {newKinesisEvent.eventDistance === 'other' && (
                        <input
                        type="text"
                        className='h-full w-full p-2 placeholder:text-gray-400 focus:outline-none bg-orange-100'
                        placeholder='Enter text'
                        value={newKinesisEvent.eventDistanceTextInput}
                        onChange={(e) => HandleNewEventDataEdit('eventDistanceTextInput', e.target.value)}
                    />
                )}

                {newKinesisEvent.eventDistance !== 'other' && (
                    <div className="h-full px-2 py-2 bg-orange-100 text-gray-500 cursor-not-allowed">
                        N/A
                    </div>
                )}
            </div>

            {/* Event Training Start Date */}
            <div className='col-span-2'>
                {newKinesisEvent.eventType === 'a-race' && 
                    <div className="relative h-full">
                        <input
                            type="date"
                            className='h-full w-full px-2 py-1 focus:outline-none text-transparent bg-orange-100 select-none cursor-pointer caret-transparent'
                            value={newKinesisEvent.eventTrainingStartDate}
                            onChange={(e) => HandleNewEventDataEdit('eventTrainingStartDate', e.target.value)}
                            onSelect={(e) => e.preventDefault()}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                e.target.showPicker?.();
                            }}
                        />

                        <div className="absolute inset-0 flex items-center pl-2 pr-8 pointer-events-none select-none">
                            {moment(newKinesisEvent.eventTrainingStartDate).format('MMMM, DD YYYY')}
                        </div>
                    </div>
                }

                {newKinesisEvent.eventType !== 'a-race' && 
                    <div className="h-full px-2 py-2 bg-orange-100 text-gray-500 cursor-not-allowed">
                        N/A
                    </div>
                }
            </div>

            {/* Event Date */}
            <div className='col-span-2'>
                <div className="relative h-full">
                    <input
                        type="date"
                        className='h-full w-full px-2 py-1 focus:outline-none text-transparent bg-orange-100 select-none cursor-pointer caret-transparent'
                        value={newKinesisEvent.eventDate}
                        onChange={(e) => HandleNewEventDataEdit('eventDate', e.target.value)}
                        onSelect={(e) => e.preventDefault()}
                        onMouseDown={(e) => {
                            e.preventDefault();
                            e.target.showPicker?.();
                        }}
                    />

                    <div className="absolute inset-0 flex items-center pl-2 pr-8 pointer-events-none select-none">
                        {moment(newKinesisEvent.eventDate).format('MMMM, DD YYYY')}
                    </div>
                </div>
            </div>

            {/* Deload After Event */}
            <div className='col-span-1'>
                {newKinesisEvent.eventType === 'a-race' && 
                    <div 
                        className='h-full flex items-center justify-center cursor-pointer bg-orange-100'
                        onClick={() => HandleNewEventDataEdit('deloadAfterEvent', newKinesisEvent.deloadAfterEvent === 1 ? 0 : 1)}
                    >
                        <Switch
                            checked={newKinesisEvent.deloadAfterEvent === 1}
                            className={`
                                scale-75 relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out
                                ${newKinesisEvent.deloadAfterEvent === 1 ? 'bg-orange-400' : 'bg-gray-200'}
                            `}
                        >
                            <span
                                aria-hidden="true"
                                className={`
                                    pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                    ${newKinesisEvent.deloadAfterEvent === 1 ? 'translate-x-5' : 'translate-x-0'}
                                `}
                            />
                        </Switch>
                    </div>
                }

                {newKinesisEvent.eventType !== 'a-race' && 
                    <div className="h-full px-2 py-2 bg-orange-100 text-gray-500 text-center cursor-not-allowed">
                        N/A
                    </div>
                }
            </div>

            {/* Delete */}
            <div className='col-span-1'>
                <div 
                    className='h-full flex items-center justify-center cursor-pointer bg-white cursor-pointer hover:bg-gray-100'
                    onClick={() => HandleNewEventDataEdit('delete')}
                >
                    <TrashIcon className='h-5 text-gray-400 pointer-events-none' />
                </div>
            </div>

        </div>
    )
}
